import React from 'react';

function Header() {
  return (
    <header className='header'>
      <h1>Natural Event Tracker (Powered By NASA)</h1>
    </header>
  );
}

export default Header;
